import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import {DurationProps} from "../../types-enums/activity-common-properties"
import {AllActivityTypes, AllActivityTypesArray} from "../../types-enums/activity"
import {Customer} from "../../api/model/customer"
import {createArrayFromNumber} from "../../utils/common";
import {getActivitiesByActivityGroupId, getFirstActivityIndexById} from "../../utils/getter/activities";
import {
    addOneDayToJourney,
    changeDayOfActivitiesOnLastDayOfJourney,
    getNewJourneyDuration,
    splitAndAddActivityToJourney,
    updateDateInJourneyDuration,
    updateJourneyDurationWithDays
} from "./journey-utils";
import {DaysRange} from "../../components/activity/hotel/choose-hotel/utils";
import {mergeTravelComponentsToJourneyElements} from "../../utils/converter/travel-components";
import cloneDeep from "lodash/cloneDeep";
import {BundleForStore} from "../../api/model/bundle";
import {getDurationInDaysOrNights} from "../../utils/getter/common";
import {
    CommonBundleProps,
    updateBundleOnDeleteAgency,
    updateBundlePropsOnCreateOrUpdate,
    UpdateDataOnCreateUpdateBundle,
    updateHideLoadBundleInformation
} from "./common";
import {isEqual} from "lodash";
import {completeInitialCustomer} from "../../components/forms/customer-form/CustomerForm";
import {AgencyProps} from "../../api/model/agency";
import {
    addDatesToActivitiesWhenChangeDateOnDayChange,
    removeDatesFromActivitiesWhenChangeDateOnDayChange,
    removeDatesFromActivitiesWhenRecalculateOnDifferentDate
} from "../../utils/setter/activities";
import {hasExactDates} from "../../utils/getter/journey";

export interface CreateJourneyProps {
    customer: Customer | null,
    name: string,
    description: string | null,
    agency: AgencyProps,
    journeyDuration: DurationProps,
    personCount: number,
    activities: AllActivityTypesArray,
}

export interface QueueForDeleteDayProps {
    [key: string]: {
        day: number,
        activities: AllActivityTypesArray
    }
}

export const DEFAULT_JOURNEY = {
    bundleId: null,
    name: null,
    description: null,
    activities: [],
    customer: null,
    journeyDuration: {
        dates: null,
        daysOrNights: 0
    },
    personCount: 1,
}

export interface JourneyState extends CommonBundleProps {
    personCount: number,
    journeyDuration: DurationProps,
    activities: AllActivityTypesArray
    queueForDeleteActivity: {
        [key: string]: {
            id: string,
            activities: AllActivityTypesArray
        }
    },
    queueForDeleteDay: QueueForDeleteDayProps
}

const initialState: JourneyState = {
    ...DEFAULT_JOURNEY,
    // name: "This is some Journey Title which probably exceeds the width of the pdf",
    // description: "This is some Journey Description which probably exceeds the width of the pdf page and needs to be truncated",
    // journeyDuration: {
    //     dates: null,
    //     daysOrNights: 5
    // },
    // activities: JSON.parse('[{"common":{"activityType":"hotel","travelOptionType":"accommodation","day":2,"editId":null,"hideLoadBundleInformation":false,"groupId":"dbc065ef-b7ce-4bb0-bc0c-8a49e7a3ec9c","id":"2aa0149f-0d6a-44b2-8762-6d2b47b94ecd","semanticId":"787db1c5-4693-48a7-8974-f46538756f60","originalRequest":[{"hotelName":"Florence","city":"Daylesford","region":null,"country":"AUS","index":0,"type":"hotel","hotelClass":4,"roomCategory":"DS","numberOfRooms":1,"numberOfNights":2,"numberOfPeople":1,"mealPlan":null}],"request":[{"hotelName":"Florence","city":"Daylesford","region":null,"country":"AUS","index":0,"type":"hotel","hotelClass":4,"roomCategory":"DS","numberOfRooms":1,"numberOfNights":1,"numberOfPeople":1,"mealPlan":null}],"totalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":39.19,"scope":"COUNTRY","errorCodes":null,"type":"hotel","errors":null}],"originalTotalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":78.375,"scope":"COUNTRY","errorCodes":null,"type":"hotel","errors":null}]},"hotel":{"id":1210873,"name":"Florence","city":"Daylesford","alpha2":"AU","alpha3":"AUS","stars":"FOUR","countryName":"Australia"},"city":{"id":1,"name":"Daylesford","alpha2":"AU","alpha3":"AUS","countryName":"Australia"},"country":{"id":1,"alpha2":"AU","alpha3":"AUS","name":"Australia"},"hotelClass":"FOUR","roomCategory":"DS","hotelStayDuration":{"dates":null,"daysOrNights":1},"originalHotelStayDuration":{"dates":null,"daysOrNights":2},"guestCount":1,"numberOfRooms":1,"mealPlan":null,"informationFromLoadedBundle":null,"backendId":null},{"common":{"activityType":"hotel","travelOptionType":"accommodation","day":3,"editId":null,"hideLoadBundleInformation":false,"groupId":"dbc065ef-b7ce-4bb0-bc0c-8a49e7a3ec9c","id":"5e6db887-8bba-43cb-9706-955891a2759e","semanticId":"787db1c5-4693-48a7-8974-f46538756f60","originalRequest":[{"hotelName":"Florence","city":"Daylesford","region":null,"country":"AUS","index":0,"type":"hotel","hotelClass":4,"roomCategory":"DS","numberOfRooms":1,"numberOfNights":2,"numberOfPeople":1,"mealPlan":null}],"request":[{"hotelName":"Florence","city":"Daylesford","region":null,"country":"AUS","index":0,"type":"hotel","hotelClass":4,"roomCategory":"DS","numberOfRooms":1,"numberOfNights":1,"numberOfPeople":1,"mealPlan":null}],"totalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":39.19,"scope":"COUNTRY","errorCodes":null,"type":"hotel","errors":null}],"originalTotalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":78.375,"scope":"COUNTRY","errorCodes":null,"type":"hotel","errors":null}]},"hotel":{"id":1210873,"name":"Florence","city":"Daylesford","alpha2":"AU","alpha3":"AUS","stars":"FOUR","countryName":"Australia"},"city":{"id":1,"name":"Daylesford","alpha2":"AU","alpha3":"AUS","countryName":"Australia"},"country":{"id":1,"alpha2":"AU","alpha3":"AUS","name":"Australia"},"hotelClass":"FOUR","roomCategory":"DS","hotelStayDuration":{"dates":null,"daysOrNights":1},"originalHotelStayDuration":{"dates":null,"daysOrNights":2},"guestCount":1,"numberOfRooms":1,"mealPlan":null,"informationFromLoadedBundle":null,"backendId":null},{"common":{"activityType":"car_bus","travelOptionType":"transport","day":3,"editId":null,"id":"ccff6fd3-85a6-4977-801f-7ed4ff8b7ae5","hideLoadBundleInformation":false,"groupId":"15caf0d3-e11a-40f7-b2f6-0e27d352e9b3","semanticId":"eddad27a-cd1c-4f78-bf8d-5907ca18e317","originalRequest":[{"index":0,"type":"car","vehicleType":"CAR","numberOfPassengers":1,"fuelConsumption":null,"fuelType":"DIESEL","distance":123,"daysOfUse":2,"carInfo":{"acrissCode":null,"carCategory":"MIDDLE_CLASS"},"busCategory":null,"isHybrid":false}],"request":[{"index":0,"type":"car","vehicleType":"CAR","numberOfPassengers":1,"fuelConsumption":null,"fuelType":"DIESEL","distance":123,"daysOfUse":1,"carInfo":{"acrissCode":null,"carCategory":"MIDDLE_CLASS"},"busCategory":null,"isHybrid":false}],"totalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":9.78,"errorCodes":null,"type":"car","errors":null}],"originalTotalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":19.557,"errorCodes":null,"type":"car","errors":null}]},"vehicleType":"CAR","fuelConsumption":null,"manualEnteredDistanceKm":61.5,"calculatedDistanceKm":null,"fuelType":"DIESEL","busCategory":null,"carCategory":"MIDDLE_CLASS","acrissCode":null,"countDays":1,"passengerCount":1,"isHybrid":false,"waypoints":[],"originalWaypoints":[],"originalRoute":null,"originalCountDays":2,"route":null,"informationFromLoadedBundle":null,"backendId":null},{"common":{"activityType":"car_bus","travelOptionType":"transport","day":4,"editId":null,"id":"6442acef-675f-4490-8e4c-1d4c48ea7050","hideLoadBundleInformation":false,"groupId":"15caf0d3-e11a-40f7-b2f6-0e27d352e9b3","semanticId":"eddad27a-cd1c-4f78-bf8d-5907ca18e317","originalRequest":[{"index":0,"type":"car","vehicleType":"CAR","numberOfPassengers":1,"fuelConsumption":null,"fuelType":"DIESEL","distance":123,"daysOfUse":2,"carInfo":{"acrissCode":null,"carCategory":"MIDDLE_CLASS"},"busCategory":null,"isHybrid":false}],"request":[{"index":0,"type":"car","vehicleType":"CAR","numberOfPassengers":1,"fuelConsumption":null,"fuelType":"DIESEL","distance":123,"daysOfUse":1,"carInfo":{"acrissCode":null,"carCategory":"MIDDLE_CLASS"},"busCategory":null,"isHybrid":false}],"totalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":9.78,"errorCodes":null,"type":"car","errors":null}],"originalTotalEmissions":[{"index":0,"status":"SUCCESS","emissionKgCO2e":19.557,"errorCodes":null,"type":"car","errors":null}]},"vehicleType":"CAR","fuelConsumption":null,"manualEnteredDistanceKm":61.5,"calculatedDistanceKm":null,"fuelType":"DIESEL","busCategory":null,"carCategory":"MIDDLE_CLASS","acrissCode":null,"countDays":1,"passengerCount":1,"isHybrid":false,"waypoints":[],"originalWaypoints":[],"originalRoute":null,"originalCountDays":2,"route":null,"informationFromLoadedBundle":null,"backendId":null}]'),
    personCount: 1,
    created: null,
    updated: null,
    queueForDeleteActivity: {},
    queueForDeleteDay: {},
    agency: null,
    userId: null,
}

export const journeySlice = createSlice({
    name: 'journey',
    initialState,
    reducers: {
        updateJourneyOnDeleteAgency: (state, action: PayloadAction<AgencyProps>) => updateBundleOnDeleteAgency(state, action.payload),
        createJourney: (state, action: PayloadAction<CreateJourneyProps>) => {
            const {
                payload: {
                    customer,
                    name,
                    personCount,
                    description,
                    journeyDuration,
                    activities,
                    agency
                }
            } = action
            const {dates, daysOrNights} = journeyDuration
            state.bundleId = null
            state.customer = customer
            state.name = name
            state.description = description
            state.personCount = personCount
            state.activities = activities
            state.agency = agency
            if (hasExactDates(journeyDuration)) {
                const {startDate, endDate} = dates!!
                if (state.journeyDuration.dates) {
                    state.journeyDuration.dates.endDate = endDate
                    state.journeyDuration.dates.startDate = startDate
                } else {
                    state.journeyDuration.dates = {endDate, startDate}
                }
                if (state.journeyDuration.daysOrNights) state.journeyDuration.daysOrNights = null
            } else {
                state.journeyDuration.daysOrNights = daysOrNights
                if (state.journeyDuration.dates) state.journeyDuration.dates = null
            }

        },
        updateActivityInJourney: (state, action: PayloadAction<{
            activity: AllActivityTypes,
            travelComponentActivities: AllActivityTypesArray,
            day: number
        }>) => {
            const {payload: {day, activity: updatedActivity, travelComponentActivities}} = action
            const {journeyDuration} = state
            const {common: {groupId: updatedActivityGroupId, id: updatedActivityId}} = updatedActivity
            const activitiesWithoutUpdatedActivity = cloneDeep(state.activities).filter(activity => {
                if (updatedActivityGroupId !== null) return activity.common.groupId !== updatedActivityGroupId
                return activity.common.id !== updatedActivityId
            })
            const updatedActivities = splitAndAddActivityToJourney(updatedActivity, day, activitiesWithoutUpdatedActivity, travelComponentActivities, journeyDuration)
            const journeyDurationInDays = getDurationInDaysOrNights(state.journeyDuration, false)
            if (journeyDurationInDays !== null) state.activities = mergeTravelComponentsToJourneyElements(updatedActivities, journeyDurationInDays, false, false)
        },
        replaceActivitiesInJourney: (state, action: PayloadAction<AllActivityTypesArray>) => {
            state.activities = action.payload
        },
        deleteDayFromJourney: (state, action: PayloadAction<{
            id: string,
            day: number
        }>) => {
            const {payload: {day: dayToDelete, id}} = action
            const {journeyDuration} = state
            const currentDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
            if (currentDurationInDays !== null) {
                const newDurationInDays = currentDurationInDays - 1
                state.journeyDuration = getNewJourneyDuration(journeyDuration, newDurationInDays)
            }
            state.queueForDeleteDay[id] = {
                day: dayToDelete,
                activities: state.activities.filter(activity => activity.common.day === dayToDelete)
            }
        },
        undoDeleteDayFromJourney: (state, action: PayloadAction<string>) => {
            addOneDayToJourney(state)
        },
        deleteDayFromJourneyDayQueue: (state, action: PayloadAction<string>) => {
            delete state.queueForDeleteDay[action.payload]
        },
        deleteJourney: state => {
            return {...initialState}
        },
        deleteActivityFromJourney: (state, action: PayloadAction<{
            activity: AllActivityTypes,
            queueId: string,
            deleteGroup: boolean,
        }>) => {
            const {activity, queueId, deleteGroup} = action.payload
            const {common: {groupId}} = activity
            let activitiesToDelete: AllActivityTypesArray | null
            if (deleteGroup) {
                activitiesToDelete = getActivitiesByActivityGroupId(state.activities, groupId)
            } else {
                activitiesToDelete = [activity]
            }

            if (activitiesToDelete !== null) {
                const {common: {groupId, id}} = activitiesToDelete[0]
                let updatedActivities: AllActivityTypesArray
                if (groupId !== null && deleteGroup) {
                    updatedActivities = state.activities.filter(activity => activity.common.groupId !== groupId)
                } else {
                    updatedActivities = state.activities.filter(activity => activity.common.id !== id)
                }
                state.queueForDeleteActivity[queueId] = {id, activities: activitiesToDelete}
                state.activities = mergeTravelComponentsToJourneyElements(updatedActivities, getDurationInDaysOrNights(state.journeyDuration, false)!!, false, false)
            }
        },
        undoDeleteActivityFromJourney: (state, action: PayloadAction<{
            queueId: string,
            updateActivities: boolean
        }>) => {
            const {payload: {queueId, updateActivities}} = action
            if (updateActivities) {
                const item = state.queueForDeleteActivity[queueId]
                const {activities} = item
                const updatedActivities = cloneDeep(state.activities)
                updatedActivities.push(...activities)
                state.activities = mergeTravelComponentsToJourneyElements(updatedActivities, getDurationInDaysOrNights(state.journeyDuration, false)!!, false, false)
                delete state.queueForDeleteActivity[queueId]
            } else {
                delete state.queueForDeleteActivity[queueId]
            }
        },
        deleteActivityFromJourneyActivityQueue: (state, action: PayloadAction<string>) => {
            delete state.queueForDeleteActivity[action.payload]
        },
        addDayToJourney: state => addOneDayToJourney(state),
        removeExactDateFromJourney: (state) => {
            const {journeyDuration} = state
            const journeyDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
            const updatedActivities = cloneDeep(state.activities)
            removeDatesFromActivitiesWhenRecalculateOnDifferentDate(updatedActivities)
            removeDatesFromActivitiesWhenChangeDateOnDayChange(updatedActivities)
            state.journeyDuration.dates = null
            state.journeyDuration.daysOrNights = journeyDurationInDays
            state.activities = updatedActivities
        },
        changeJourneyDuration: (state, action: PayloadAction<number | DaysRange>) => {
            const {payload} = action
            const {journeyDuration} = state
            const previousDurationInDays = getDurationInDaysOrNights(journeyDuration, false)
            const newJourneyDuration = getNewJourneyDuration(journeyDuration, payload)
            const newDurationInDays = getDurationInDaysOrNights(newJourneyDuration, false)
            if (newDurationInDays !== null && previousDurationInDays !== null) {
                let updatedActivities = cloneDeep(state.activities).filter(activity => createArrayFromNumber(newDurationInDays).includes(activity.common.day!!))
                updatedActivities = changeDayOfActivitiesOnLastDayOfJourney(updatedActivities, newDurationInDays)
                if (typeof payload !== 'number') {
                    updateDateInJourneyDuration(state, payload)
                    const {startDate} = payload
                    const mergedUpdatedActivities = mergeTravelComponentsToJourneyElements(
                        updatedActivities,
                        newDurationInDays,
                        false,
                        false
                    )
                    addDatesToActivitiesWhenChangeDateOnDayChange(mergedUpdatedActivities, startDate)
                    state.activities = mergedUpdatedActivities
                } else {
                    if (typeof action.payload === 'number') updateJourneyDurationWithDays(cloneDeep(state.journeyDuration), action.payload, state.journeyDuration)
                    state.activities = mergeTravelComponentsToJourneyElements(
                        updatedActivities,
                        newDurationInDays,
                        false,
                        false
                    )
                }
            }
        },
        addPersonToJourney: (state, action: PayloadAction<number>) => {
            state.personCount = action.payload
        },
        changeJourneyName: (state, action: PayloadAction<string>) => {
            const newName = action.payload
            if (newName.length === 0) {
                state.name = null
            } else {
                state.name = action.payload
            }
        },
        changeJourneyDescription: (state, action: PayloadAction<string>) => {
            const newDescription = action.payload
            if (newDescription.length === 0) {
                state.description = null
            } else {
                state.description = action.payload
            }
        },
        addActivityToJourney: (state, action: PayloadAction<{
            activity: AllActivityTypes,
            travelComponentActivities: AllActivityTypesArray,
            day: number
        }>) => {
            const {payload: {activity, day, travelComponentActivities}} = action
            const {activities: journeyActivities, journeyDuration} = state
            const updatedActivities = splitAndAddActivityToJourney(activity, day, journeyActivities, travelComponentActivities, journeyDuration)
            const journeyDurationInDays = getDurationInDaysOrNights(state.journeyDuration, false)
            if (journeyDurationInDays !== null) state.activities = mergeTravelComponentsToJourneyElements(updatedActivities, journeyDurationInDays, false, false)
        },
        moveActivityToDay: (state, action: PayloadAction<{
            id: string,
            day: number
        }>) => {
            const {payload: {id, day}} = action
            const activityToMoveIndex = getFirstActivityIndexById(state.activities, id)
            if (activityToMoveIndex > -1) state.activities[activityToMoveIndex].common.day = day
        },
        loadJourney: (state, action: PayloadAction<BundleForStore>) => {
            const {payload} = action
            if (payload.journeyDuration !== null) return {
                ...state,
                ...payload,
                journeyDuration: payload.journeyDuration ?? {} as DurationProps // only for compiler needed
            }
        },
        updateJourneyProps: (state, action: PayloadAction<UpdateDataOnCreateUpdateBundle>) => {
            return updateBundlePropsOnCreateOrUpdate(action.payload, state) as JourneyState
        },
        updateJourneyCustomer: (state, action: PayloadAction<Customer | null>) => {
            const {payload} = action
            state.customer = isEqual(payload, completeInitialCustomer) ? null : payload
        },
        setJourneyHideLoadBundleInformation: (state, action: PayloadAction<{ activityId: string, value: boolean }>) => {
            const {activityId, value} = action.payload
            state.activities = updateHideLoadBundleInformation(state.activities, activityId, value)
        }
    }
});

export const {
    deleteDayFromJourney,
    undoDeleteDayFromJourney,
    deleteJourney,
    deleteActivityFromJourney,
    undoDeleteActivityFromJourney,
    deleteActivityFromJourneyActivityQueue,
    deleteDayFromJourneyDayQueue,
    createJourney,
    changeJourneyDuration,
    addPersonToJourney,
    changeJourneyName,
    addActivityToJourney,
    updateActivityInJourney,
    moveActivityToDay,
    replaceActivitiesInJourney,
    addDayToJourney,
    removeExactDateFromJourney,
    loadJourney,
    changeJourneyDescription,
    updateJourneyProps,
    updateJourneyCustomer,
    updateJourneyOnDeleteAgency,
    setJourneyHideLoadBundleInformation
} = journeySlice.actions
export default journeySlice.reducer;